<h2 mat-dialog-title>Patients with Missing Procedure Consents</h2>
<mat-dialog-content>
    <div class="list-container">
        <div class="scrollable-list">
            <mat-list *ngIf="patients && patients.length; else noResults">
                <mat-list-item *ngFor="let patient of patients" (click)="selectPatient(patient)"
                    class="auto-height">
                    <div class="list-item">
                        <div class="details">
                            <div matLine class="primary-text">
                                <b>{{ patient.surname }}, {{ patient.name }}</b>
                                <span class="primary-text-aside" *ngIf="patient.patientNumber"> ({{
                                    patient.patientNumber
                                    }})</span>
                            </div>
                            <div matLine class="secondary-text">
                                <span *ngIf="patient.appointmentCount > 0">
                                    {{ patient.appointmentCount }} upcoming {{ patient.appointmentCount === 1 ? 'appointment' : 'appointments' }}
                                </span>
                                <span *ngIf="patient.signedConsentCount !== undefined">
                                    • {{ patient.signedConsentCount }} signed {{ patient.signedConsentCount === 1 ? 'consent' : 'consents' }}
                                </span>
                                <span *ngIf="patient.unsignedConsentCount > 0" class="warning-text">
                                    • {{ patient.unsignedConsentCount }} unsigned {{ patient.unsignedConsentCount === 1 ? 'consent' : 'consents' }}
                                </span>
                            </div>
                        </div>
                        <div class="view-icon">
                            <mat-icon>visibility</mat-icon>
                        </div>
                    </div>
                </mat-list-item>
            </mat-list>
            <ng-template #noResults>
                <p class="grey-text">No patients found.</p>
            </ng-template>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Close</button>
</mat-dialog-actions>

